// extracted by mini-css-extract-plugin
module.exports = {"container":"CallToAction-module__container___9_WW6","text":"CallToAction-module__text___twnnu"};